module.exports = __webpack_public_path__ + "static/img/JoinProcess.9fe24754.png";